import styled from 'styled-components';
import triangleIcon from '../../../images/triangle.svg';
import { colors } from '../../variables';

const TableHeader = styled.header`
	padding-right: 30px;
	background: #fff;
	padding: 20px;
	text-transform: uppercase;
	border: 1px solid ${colors.grey.normal};

	${props =>
		props.collapsable &&
		`
		cursor: pointer;

		&:after {
			background: url(${triangleIcon}) no-repeat center;
			background-size: contain;
			content: '';
			display: inline-block;
			margin-left: 10px;
			width: 12px;
			height: 12px;
			transition: transform 0.3s ease-out;

			${props.expanded &&
				`
				transform: rotate(180deg);
			`}
		}
	`};
`;

export default TableHeader;



// WEBPACK FOOTER //
// ./src/components/Common/Table/TableHeader.js